var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_c('h2',[_vm._v(" Sorry, that page doesn't exist. ")]),_c('button',{on:{"click":_vm.goBack}},[_vm._v("Go Home")])])])}
var staticRenderFns = []

export { render, staticRenderFns }